function epochToDate(epoch) {
    const date = new Date(epoch * 1000)
    return date.toLocaleString()
}

export default epochToDate